exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-plan[data-v-4a3fb702]{cursor:pointer}", ""]);

// exports
